export default __webpack_public_path__ + "static/media/discount.8c86f20a.svg";